(function () {
  function cleanEmptyPriceParams() {
    if (window.location.search.indexOf('filter.v.price') === -1) return;
    var params = new URLSearchParams(window.location.search);
    var gte = params.get('filter.v.price.gte');
    var lte = params.get('filter.v.price.lte');
    if ((gte === '' || gte === null) && (lte === '' || lte === null)) {
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      var qs = params.toString();
      var url = window.location.pathname + (qs ? '?' + qs : '');
      window.history.replaceState({}, '', url);
    }
  }

  function bindPriceForms() {
    document.querySelectorAll('[data-bioniks-price-filter]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var g = form.querySelector('[name="filter.v.price.gte"]');
        var l = form.querySelector('[name="filter.v.price.lte"]');
        if (!g || !l) return;
        if (!String(g.value || '').trim() && !String(l.value || '').trim()) {
          e.preventDefault();
          return;
        }
        if (!String(g.value || '').trim()) g.disabled = true;
        if (!String(l.value || '').trim()) l.disabled = true;
      });
    });
  }

  function brandRailTagSuffix() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    if (parts[0] === 'collections' && parts.length > 2) {
      return '/' + parts.slice(2).join('/');
    }
    return '';
  }

  function fixBrandRailLinks() {
    var suffix = brandRailTagSuffix();
    var map = {
      '\u2217': '/collections/tum-urunler',
      DM: '/collections/dr-misimou',
      B: '/collections/bioniks'
    };
    document.querySelectorAll('.wardah-brand-rail__scroll .wardah-brand-pill').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href && href !== '' && href !== '#') return;
      var mono = a.querySelector('.wardah-brand-pill__mono');
      if (!mono) return;
      var key = mono.textContent.trim();
      if (map[key]) a.setAttribute('href', map[key] + suffix);
    });
  }

  function init() {
    cleanEmptyPriceParams();
    bindPriceForms();
    fixBrandRailLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
